import { useStorage } from "@vueuse/core";
import { defineStore } from "pinia";
import { ref, onMounted } from "vue";

import { getMenuLinks } from "../api/getMenuLinks";

export const useSidebarStore = defineStore("SidebarStore", () => {
    const menuLinks = ref([]);
    const isCollapsed = useStorage(
        "is-sidebar-collapsed",
        window.innerWidth <= 576,
        localStorage
    );
    // Раскрытые группы меню помним между заходами: приёмщик, кладовщик и
    // руководитель держат открытыми разные разделы, схлопывать их незачем
    const openedSections = useStorage(
        "sidebar-opened-sections",
        {},
        localStorage
    );

    async function fetchMenuLinks() {
        menuLinks.value = await getMenuLinks();
    }

    function setMenuLinks(array) {
        menuLinks.value = array;
    }

    // Пока пользователь не трогал группу — значения нет, и пункт меню решает
    // сам (по defaultOpened и активному маршруту внутри группы)
    function isSectionOpened(key) {
        return openedSections.value[key];
    }

    function setSectionOpened(key, value) {
        openedSections.value[key] = value;
    }

    function setCollapsedMode(value) {
        isCollapsed.value = value;
        toggleSidebarAppClass();
    }

    function toggleCollapsedMode() {
        isCollapsed.value = !isCollapsed.value;
        toggleSidebarAppClass();
    }

    function toggleSidebarAppClass() {
        const app = document.querySelector("#app");

        if (isCollapsed.value) {
            app.setAttribute("aria-expanded", "false");
        } else {
            app.setAttribute("aria-expanded", "true");
        }
    }

    onMounted(() => {
        toggleSidebarAppClass();
    });

    return {
        menuLinks,
        isCollapsed,
        openedSections,
        isSectionOpened,
        setSectionOpened,
        setMenuLinks,
        fetchMenuLinks,
        setCollapsedMode,
        toggleCollapsedMode,
    };
});
